import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectPlannerData = state => selectState(state).data;
export const selectElements = createSelector(selectPlannerData, data =>
  data.elements.filter(element => !element.deleted),
);
export const selectPrograms = state => selectState(state).data.programs;
export const selectChannels = state => selectState(state).data.channels;
export const isPlannerLoading = state => selectState(state).loading;
export const selectPlanFilters = state => selectState(state).filters;

export const selectFilteredPlans = createSelector(
  [selectPrograms, selectPlanFilters],
  (data, { searchText /* , status, start, end */ }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );

    // 🔽 NEW CODE (commented out)
    // export const selectFilteredPlans = createSelector(
    //   [selectPrograms, selectPlanFilters],
    //   (data, { searchText, status, start, end }) => {
    // return data.filter(entry => {
    //   const matchesText = searchText
    //     ? Object.keys(entry).some(key =>
    //         String(entry[key]).toLowerCase().includes(searchText.toLowerCase())
    //       )
    //     : true;

    //   const matchesStatus = status ? entry.status === status : true;

    //   const matchesDate =
    //     (start ? new Date(entry.since) >= new Date(start) : true) &&
    //     (end ? new Date(entry.till) <= new Date(end) : true);

    //   return matchesText && matchesStatus && matchesDate;
    // });
  },
);
